import React from "react";
import styles from "./index.module.scss";
import dayjs from "dayjs";
import { Badge, Form } from "react-bootstrap";
import { teams } from "../../constants";
import { useMutation } from "react-query";
import API from "../../api";
import { rndInt } from "../../helpers/utils";
import Image from "react-graceful-image";

const getFeedIcon = (feedUrl) => {
  if (/youtube/.test(feedUrl)) {
    return "yt.png";
  } else if (/megogo/.test(feedUrl)) {
    return "mg.png";
  } else {
    return "";
  }
};

const RoundMatches = ({
  currentRound,
  roundMatches = [],
  isAdmin = false,
  setMatchLoading = () => undefined,
}) => {
  const { mutate } = useMutation({
    mutationFn: (body) => {
      setMatchLoading(true);
      return API.saveSettings(body);
    },
    onSuccess: () => {
      setMatchLoading(false);
    },
  });

  const onChangeCheckBox = (event, roundMatch) => {
    const { checked } = event.target;
    const body = {
      currentRound,
      matchInfo: {
        MatchId: roundMatch.MatchId,
        isReadyForCalculation: checked,
      },
    };
    mutate(body);
  };

  return (
    <div style={{ marginTop: 8 }}>
      <h5 className={styles.title}>
        <i className="bi bi-calendar"></i>&nbsp;ТУР {currentRound}
      </h5>
      {roundMatches.map((roundMatch) => (
        <div key={roundMatch.MatchId} className={styles.listItem}>
          <div className={styles.cnt}>
            <Badge
              bg="success"
              style={{
                width: 90,
                height: 25,
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
              }}
            >
              {dayjs(roundMatch.Deadline).format("DD.MM HH:mm")}
            </Badge>
            <div className={styles.details}>
              {isAdmin && (
                <div
                  className={styles.matchId}
                  style={{ color: "#0dcaf0", marginRight: 8 }}
                >
                  {roundMatch.MatchId}
                </div>
              )}
              <div className={styles.score}>
                <div
                  className={styles.detailsItem}
                  style={{ textAlign: "left" }}
                >
                  <div style={{ width: 74 }}>
                    <div
                      className={styles.cnt}
                      style={{ justifyContent: "flex-start" }}
                    >
                      <Image
                        style={{
                          borderRadius: "100%",
                          minHeight: 30,
                          backgrounColor: "#fff",
                          marginRight: 4,
                        }}
                        src={`https://media-${rndInt()}.api-sports.io/football/teams/${
                          roundMatch.FirstTeam
                        }.png`}
                        width={30}
                        alt=""
                      />
                      {teams[roundMatch.FirstTeam].shortName}
                    </div>
                  </div>{" "}
                  <Badge bg="warning" style={{ color: "#000", width: 35 }}>
                    {roundMatch.FirstScore !== undefined
                      ? roundMatch.FirstScore
                      : "-"}
                    :
                    {roundMatch.SecondScore !== undefined
                      ? roundMatch.SecondScore
                      : "-"}
                  </Badge>
                  <div
                    className={styles.cnt}
                    style={{ width: 68, marginLeft: 12 }}
                  >
                    {teams[roundMatch.SecondTeam].shortName}
                    <Image
                      style={{
                        borderRadius: "100%",
                        minHeight: 30,
                        backgrounColor: "#fff",
                        marginLeft: 4,
                      }}
                      src={`https://media-${rndInt()}.api-sports.io/football/teams/${
                        roundMatch.SecondTeam
                      }.png`}
                      width={30}
                      alt=""
                    />
                  </div>
                </div>
              </div>
            </div>
          </div>

          {isAdmin ? (
            <div>
              <Form.Check // prettier-ignore
                type="checkbox"
                defaultChecked={roundMatch.isReadyForCalculation}
                onChange={(e) => onChangeCheckBox(e, roundMatch)}
              />
            </div>
          ) : (
            <div className={styles.rightCnt}>
              <div style={{ display: "none" }} className={styles.feedCnt}>
                <a
                  href={
                    roundMatch.FeedUrl ?? teams[roundMatch.FirstTeam].feedUrl
                  }
                  target="_blank"
                  rel="noreferrer"
                >
                  <Image
                    className={styles.feed}
                    src={getFeedIcon(
                      roundMatch.FeedUrl ?? teams[roundMatch.FirstTeam].feedUrl
                    )}
                    alt=""
                  />
                </a>
                <div
                  className={styles.feedLayer}
                  onClick={() => {
                    window.gtag &&
                      window.gtag("event", "feed", {
                        target: `${teams[roundMatch.FirstTeam].shortName} - ${
                          teams[roundMatch.SecondTeam].shortName
                        }`,
                      });
                    window.open(
                      roundMatch.FeedUrl ?? teams[roundMatch.FirstTeam].feedUrl,
                      "_blank"
                    );
                  }}
                ></div>
              </div>
              <div style={{ position: "relative", top: 2 }}>
                {roundMatch.Calculated ? (
                  <i
                    className="bi bi-check-circle-fill"
                    style={{ color: "green" }}
                  ></i>
                ) : (
                  <i className="bi bi-hourglass"></i>
                )}
              </div>
            </div>
          )}
        </div>
      ))}
    </div>
  );
};

export default RoundMatches;
